import { createSelector } from '@ngrx/store';
import { ITypeExpensesState } from './type-expenses.reducer';

const typeExpensesStore = (state: any) =>
  state.typeExpenses as ITypeExpensesState;

export const selectTypeExpensesLista = createSelector(
  typeExpensesStore,
  (state) => state.lista
);

export const selectTypeExpensesLoading = createSelector(
  typeExpensesStore,
  (state) => state.isLoading
);